module.exports = __webpack_public_path__ + "eef399de9c4310b580d25ff5199fcea5.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Regular-Oblique.eot
// module id = 401
// module chunks = 0